import { aboutInfo } from '@/mocks/home';

export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-2 bg-secondary-100/70 text-secondary-700 text-xs font-medium px-3 py-1 rounded-full mb-4">
              <i className="ri-information-line text-xs"></i>
              <span>平台介绍</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
              {aboutInfo.title}
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              专注漫画阅读，服务千万漫迷
            </p>
          </div>

          <div className="bg-background-100 border border-background-200/70 rounded-lg p-6 md:p-10">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
              <div className="lg:col-span-3">
                <div className="space-y-4 article-body">
                  {aboutInfo.paragraphs.map((p, i) => (
                    <p key={i} className="text-foreground-600 text-sm md:text-base leading-relaxed">
                      {p}
                    </p>
                  ))}
                </div>
                <div className="flex flex-wrap gap-4 mt-6">
                  <div className="flex items-center gap-2 text-sm text-foreground-500">
                    <div className="w-8 h-8 flex items-center justify-center bg-primary-100 rounded-lg">
                      <i className="ri-check-double-line text-primary-600"></i>
                    </div>
                    <span>正版授权合作</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-foreground-500">
                    <div className="w-8 h-8 flex items-center justify-center bg-accent-100 rounded-lg">
                      <i className="ri-shield-check-line text-accent-600"></i>
                    </div>
                    <span>安全无广告阅读</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-foreground-500">
                    <div className="w-8 h-8 flex items-center justify-center bg-secondary-100 rounded-lg">
                      <i className="ri-team-line text-secondary-600"></i>
                    </div>
                    <span>800万+漫迷选择</span>
                  </div>
                </div>
              </div>

              <div className="lg:col-span-2">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20cozy%20reading%20environment%20with%20a%20tablet%20displaying%20colorful%20manga%20pages%2C%20soft%20ambient%20lighting%2C%20surrounded%20by%20manga%20volumes%20on%20wooden%20shelves%2C%20minimalist%20modern%20interior%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20peaceful%20atmosphere%2C%20editorial%20photography%20style%2C%20clean%20composition%2C%20cozy%20vibe%2C%20high%20quality%20photorealistic&width=600&height=480&seq=about-manga-reading&orientation=landscape"
                  alt="古古漫画网 - 舒适漫画阅读体验"
                  className="w-full h-64 md:h-full min-h-[280px] object-cover object-top rounded-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}